import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FilterAnalytic } from '../models/analytic.model';
import { APPLICATION, GENERAL_ACTION_TYPES } from '../usage-tracking.config';
import { DashboardNavigationInfoService } from './dashboarad-navigation-info.service';

@Injectable({ providedIn: 'root' })
export abstract class FilterTrackingService {
  private readonly dashboardNavigationInfoService = inject(
    DashboardNavigationInfoService
  );
  private readonly router = inject(Router);

  public getFilterAnalytic(
    dimensionId: string,
    filterValue: string,
    dimensions: { name: string; id: string }[]
  ): FilterAnalytic {
    const action = GENERAL_ACTION_TYPES.filterClicked;
    const application = APPLICATION;
    const filterAnalytic: FilterAnalytic = {
      url: this.router.url,
      application,
      action,
      ...this.dashboardNavigationInfoService.getNavigationInfo(),
    };

    const filterName = dimensions.find(
      dimension => dimension.id === dimensionId
    ).name;
    filterAnalytic.filterName = filterName;
    filterAnalytic.filterValue = filterValue;

    return filterAnalytic;
  }
}
